import Axios from 'axios'

const axios = Axios.create({
  baseURL: 'https://auth.voiss.cc'
})

export function voissLogin () {
  return new Promise((resolve, reject) => {
    const onMessage = (e) => {
      console.log(e)
      const msg = e.data ? e.data.toString() : ''
      console.log('msg', msg)
      if (msg && msg.match(/^voiss-login:/)) {
        const data = JSON.parse(msg.replace('voiss-login:', ''))
        if (data.type === 'login') {
          window.removeEventListener('message', onMessage)
          resolve(data)
        }
      }
    }
    window.addEventListener('message', onMessage)
    window.open('https://auth.voiss.cc/login', '_blank')
  })
}

export async function getUserInfo (token) {
  const res = await axios.get('/api/info', {
    headers: {
      Authorization: 'Bearer ' + token
    }
  })
  return res.data
}
